exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-form-field {\r\n    padding-top: 10px;\r\n    width: 49%;\r\n}\r\n\r\n.mat-dialog-content {\r\n    height: 202px !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-type-add/property-type-add.component.css
// module id = ../../../../../src/app/collateralskillsets/property-type-add/property-type-add.component.css
// module chunks = main